export default {
  couriers: [],
  allCouriers: [],
  selectedCourier: [],
  zones: [],
};
